<smallstack-icon
  alias="shopping-cart"
  [color]="data()?.color"
  [size]="data()?.size"
  [theme]="data()?.theme"
  [badge]="badge | async"
  [ngStyle]="{ cursor: data()?.link ? 'pointer' : 'unset' }"
  (click)="route()"
/>
